var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 13,
  viewBox: "0 0 16 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.2727 4.67141V10.7324C15.2727 11.1164 15.1229 11.4444 14.8228 11.717C14.5227 11.9897 14.1628 12.126 13.7425 12.126H1.53024C1.1105 12.126 0.750029 11.9897 0.449908 11.717C0.150335 11.4444 0 11.1164 0 10.7324V4.67141L7.65118 7.76229L15.2727 4.67141ZM15.2727 3.73218L7.65118 6.85353L0 3.73218V1.52014C0 1.13614 0.150335 0.807543 0.449908 0.534916C0.750029 0.26229 1.1105 0.125977 1.53024 0.125977H13.7425C14.1628 0.125977 14.5227 0.26229 14.8228 0.534916C15.1229 0.807543 15.2727 1.13614 15.2727 1.52014V3.73218Z",
  fill: "white"
})));
export default SvgIconEmail;